import TKDialog from '@tk/components/tk.dialog';

export default class DIWDialog extends TKDialog {
    constructor() {
        super();
        this.dialogCloseClassName =
            this.getAttribute('data-tk-dialog-close-class-name') ||
            'tk-button tk-button--tertiary tk-button--size-l tk-button--only-icon tk-dialog__close';
    }
}
